import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { supabase } from '@/integrations/supabase/client';

const savePushToken = async (token: string) => {
  const {
    data: { user },
    error,
  } = await supabase.auth.getUser();

  if (error || !user) {
    console.log('[Push] No logged-in user, token will be saved after login');
    // Store token temporarily to save later
    localStorage.setItem('metefy_pending_push_token', token);
    return;
  }

  const { error: upsertError } = await supabase
    .from('device_push_tokens')
    .upsert(
      {
        user_id: user.id,
        token,
        platform: 'android',
      },
      { onConflict: 'user_id,token' }
    );

  if (upsertError) {
    console.error('[Push] Error saving token to Supabase', upsertError);
  } else {
    console.log('[Push] Token saved to Supabase');
    // Clear pending token if it exists
    localStorage.removeItem('metefy_pending_push_token');
  }
};

export const setupPushNotifications = async () => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  let permStatus = await PushNotifications.checkPermissions();

  if (permStatus.receive === 'prompt') {
    permStatus = await PushNotifications.requestPermissions();
  }

  if (permStatus.receive !== 'granted') {
    console.log('[Push] Permission not granted');
    return;
  }

  await PushNotifications.register();

  PushNotifications.addListener('registration', async (token) => {
    console.log('[Push] Registration token:', token.value);
    await savePushToken(token.value);
  });

  PushNotifications.addListener('registrationError', (error) => {
    console.error('[Push] Registration error:', error);
  });

  PushNotifications.addListener('pushNotificationReceived', (notification) => {
    console.log('[Push] Notification received:', notification);
  });

  PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
    console.log('[Push] Notification action performed:', notification);
  });
};


